import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_tibb-nabawi-db/artifacts/wvm4vikx_Screenshot_20260708_041833_com_whatsapp_w4b_MediaViewActivity.jpg";

/**
 * Subtle full-page watermark using the official Islamic Cure & Care logo (PNG).
 * Fixed so it stays visible while scrolling; very low opacity so it never
 * competes with content. Rendered on every page via <Layout />.
 */
const Watermark = () => {
  return (
    <div
      aria-hidden="true"
      data-testid="page-watermark"
      className="pointer-events-none fixed inset-0 z-0 overflow-hidden print:hidden"
    >
      {/* Centerpiece — large brand medallion */}
      <img
        src={LOGO_URL}
        alt=""
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 select-none"
        style={{
          width: "min(72vw, 760px)",
          height: "auto",
          opacity: 0.06,
          filter: "saturate(0.9)",
        }}
      />

      {/* Top-right small medallion */}
      <img
        src={LOGO_URL}
        alt=""
        className="absolute select-none"
        style={{
          top: "-60px",
          right: "-70px",
          width: "300px",
          height: "auto",
          opacity: 0.07,
        }}
      />

      {/* Bottom-left small medallion */}
      <img
        src={LOGO_URL}
        alt=""
        className="absolute select-none"
        style={{
          bottom: "-60px",
          left: "-70px",
          width: "280px",
          height: "auto",
          opacity: 0.06,
        }}
      />
    </div>
  );
};

export default Watermark;
